import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "wrapper p-0 p-lg-3" }
const _hoisted_2 = { class: "font-weight-bold mb-4 d-flex flex-row justify-content-between align-items-center p-3 p-lg-0" }
const _hoisted_3 = { class: "card-header bg-white" }
const _hoisted_4 = { class: "card-title d-flex flex-column" }
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "text-uppercase font-size-sm font-weight-bold d-flex flex-row align-items-center mb-0" }
const _hoisted_8 = { class: "btn bg-transparent border-blue text-blue rounded-round border-2 btn-icon mr-3" }
const _hoisted_9 = { class: "flex-fill d-flex flex-column" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "text-muted" }
const _hoisted_12 = { class: "float-right" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "icon-forward" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "media bg-light font-weight-semibold py-2" }
const _hoisted_17 = ["href"]
const _hoisted_18 = {
  key: 0,
  class: "badge badge-danger ml-3"
}
const _hoisted_19 = { class: "d-flex flex-row align-items-center" }
const _hoisted_20 = { class: "ml-1" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("small", null, "von", -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 5 ")
const _hoisted_23 = /*#__PURE__*/_createElementVNode("small", null, "Kontakten", -1)
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "icon-cog" }, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "icon-circle-down2" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = ["id"]
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "media-body p-3" }
const _hoisted_32 = { class: "alert alert-info d-flex flex-row flex-wrap align-items-center" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warning22 mr-3" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "flex-fill mr-3 mb-0" }, "Für dieses Ereignis sind keine Kontakte hinterlegt!", -1)
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "mr-2 mr-lg-3 d-flex flex-column align-items-center" }
const _hoisted_38 = { class: "media-body align-self-center" }
const _hoisted_39 = { class: "d-flex flex-column" }
const _hoisted_40 = { class: "text-muted" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list-icons" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "list-icons-item"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right15" })
    ])
  ])
], -1)
const _hoisted_42 = {
  key: 0,
  class: "media-list media-list-linked media-list-bordered"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("li", { class: "bg-light font-weight-semibold p-3 text-center" }, " Keine Interventionstypen für diese Anlage verfügbar ! ", -1)
const _hoisted_44 = [
  _hoisted_43
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LightDonutChart = _resolveComponent("LightDonutChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, pIndex) => {
      return (_openBlock(), _createElementBlock("div", {
        key: pIndex,
        class: "card mb-5"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h6", _hoisted_4, [
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(project.p_firma) + " | ", 1),
              _createElementVNode("small", null, "#" + _toDisplayString(project.pid), 1)
            ]),
            _createElementVNode("small", _hoisted_5, _toDisplayString(project.p_strasse) + " " + _toDisplayString(project.p_hnr) + ", " + _toDisplayString(project.p_plz) + " " + _toDisplayString(project.p_ort), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.systems, (system, sIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: sIndex,
              class: "mb-5"
            }, [
              _createElementVNode("legend", _hoisted_7, [
                _createElementVNode("a", _hoisted_8, [
                  _createElementVNode("i", {
                    class: _normalizeClass(system.icon),
                    "aria-hidden": "true"
                  }, null, 2)
                ]),
                _createElementVNode("span", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, [
                    _createTextVNode(_toDisplayString(system.anlage_bemerkung) + " | ", 1),
                    _createElementVNode("small", null, "#" + _toDisplayString(system.anlage_nummer), 1)
                  ]),
                  _createElementVNode("small", _hoisted_11, _toDisplayString(_ctx.stringToDate(system.anlage_einbau, "de")), 1)
                ]),
                _createElementVNode("span", _hoisted_12, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-secondary btn-sm",
                    onClick: ($event: any) => (_ctx.goToSystemSwitchingTimes(project.pid, system.anlage_id))
                  }, _hoisted_15, 8, _hoisted_13)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(system.interventionTypes, (type, tIndex) => {
                return (_openBlock(), _createElementBlock("ul", {
                  key: tIndex,
                  class: "media-list media-list-linked media-list-bordered"
                }, [
                  _createElementVNode("li", _hoisted_16, [
                    _createElementVNode("a", {
                      class: "text-body collapsed d-flex flex-row align-items-center justify-content-between w-100",
                      href: '#collapse-icon'+sIndex+'-'+tIndex,
                      "data-toggle": "collapse"
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["d-flex flex-row align-items-center", {'text-danger':type.contacts.length <= 0}])
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.interventionTypes[tIndex].name) + " ", 1),
                        (type.contacts.length <= 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Keine Kontakte konfiguriert"))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_LightDonutChart, {
                          size: 30,
                          max: 5,
                          count: type.contacts.length,
                          class: "ml-3"
                        }, null, 8, ["count"]),
                        _createElementVNode("span", _hoisted_20, [
                          _createTextVNode(_toDisplayString(type.contacts.length) + " ", 1),
                          _hoisted_21,
                          _hoisted_22,
                          _hoisted_23
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-secondary-100 text-secondary btn-sm mr-2 ml-2",
                          onClick: ($event: any) => (_ctx.showContacts(project.pid, system.anlage_id, tIndex))
                        }, _hoisted_26, 8, _hoisted_24),
                        _createElementVNode("a", {
                          href: "",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                          class: "text-body",
                          "data-toggle": "collapse",
                          "aria-expanded": "false"
                        }, _hoisted_28)
                      ])
                    ], 8, _hoisted_17)
                  ]),
                  _createElementVNode("div", {
                    class: "collapse",
                    id: 'collapse-icon'+sIndex+'-'+tIndex
                  }, [
                    (type.contacts.length <= 0)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _hoisted_33,
                              _hoisted_34,
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn bg-info btn-sm",
                                onClick: ($event: any) => (_ctx.showContacts(project.pid, system.anlage_id, tIndex))
                              }, "Jetzt anlegen", 8, _hoisted_35)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type.contacts, (contact, cIndex) => {
                      return (_openBlock(), _createElementBlock("li", { key: cIndex }, [
                        _createElementVNode("a", {
                          class: "media cursor-pointer align-items-center p-1 p-lg-2",
                          onClick: ($event: any) => (_ctx.showEmployee(contact))
                        }, [
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("a", {
                              class: _normalizeClass(["btn bg-transparent rounded-pill border-2 btn-icon ml-3 mr-3", 'border-'+_ctx.userStatus[_ctx.filteredEmployees[contact]?.status]?.class])
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass(["icon-user", 'text-'+_ctx.userStatus[_ctx.filteredEmployees[contact]?.status]?.class])
                              }, null, 2)
                            ], 2),
                            _createElementVNode("small", {
                              class: _normalizeClass('text-'+_ctx.userStatus[_ctx.filteredEmployees[contact]?.status]?.class)
                            }, _toDisplayString(_ctx.userStatus[_ctx.filteredEmployees[contact]?.status]?.name), 3)
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createTextVNode(_toDisplayString(_ctx.filteredEmployees[contact]?.firstName) + " " + _toDisplayString(_ctx.filteredEmployees[contact]?.lastName) + " ", 1),
                              _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.filteredEmployees[contact]?.email), 1)
                            ])
                          ]),
                          _hoisted_41
                        ], 8, _hoisted_36)
                      ]))
                    }), 128))
                  ], 8, _hoisted_29)
                ]))
              }), 128)),
              (!system.interventionTypes)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_42, _hoisted_44))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}